import { useCallback, useState } from 'react';
import { logger } from '../../utils/logger';
import { PanelMode } from './call-card.types';

export function useCallCardPanel(onTransfer: () => void, onConference: () => void) {
  const [panelMode, setPanelMode] = useState<PanelMode>(null);

  const handleTransferClick = useCallback(() => setPanelMode('transfer'), []);
  const handleConferenceClick = useCallback(() => setPanelMode('conference'), []);
  const handlePanelClose = useCallback(() => setPanelMode(null), []);

  const handlePanelComplete = useCallback(
    (target?: string) => {
      if (panelMode === 'transfer') {
        onTransfer();
      } else if (panelMode === 'conference') {
        onConference();
      }
      setPanelMode(null);
      logger.debug('[CallCard] Panel operation complete:', panelMode, target);
    },
    [panelMode, onTransfer, onConference]
  );

  return {
    panelMode,
    isPanelOpen: panelMode !== null,
    handleTransferClick,
    handleConferenceClick,
    handlePanelClose,
    handlePanelComplete,
  };
}
